/**
 * WishlistCard Component - Individual wishlist item card
 */
import React, { useState } from 'react';

const WishlistCard = ({ item, isDarkMode, getCityName, cities, onPurchase, onDelete }) => {
  const [showPurchaseForm, setShowPurchaseForm] = useState(false);
  const [purchasePrice, setPurchasePrice] = useState(item.target_price || '');
  const [purchaseCity, setPurchaseCity] = useState('');
  
  return (
    <div className={`p-3 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-white border'}`}>
      {!showPurchaseForm ? (
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span className="text-lg">⭐</span>
              <span className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>{item.name}</span>
            </div>
            <div className="flex items-center gap-2 mt-1 text-sm">
              {item.target_price > 0 && (
                <span className={isDarkMode ? 'text-yellow-400' : 'text-yellow-600'}>
                  Target: {item.target_price} DH
                </span>
              )}
              {item.city_id && (
                <span className={`text-xs ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>
                  📍 {getCityName(item.city_id)}
                </span>
              )}
            </div>
            {item.note && (
              <p className={`text-xs mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{item.note}</p>
            )}
          </div>
          <div className="flex gap-1">
            <button
              onClick={() => setShowPurchaseForm(true)}
              className="px-2 py-1 text-xs bg-green-500 text-white rounded hover:bg-green-600"
            >
              ✓ Bought
            </button>
            <button onClick={onDelete} className="p-1 text-red-500 hover:text-red-600">🗑️</button>
          </div>
        </div>
      ) : (
        <div className="space-y-2">
          <p className={`text-sm font-medium ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
            Mark &quot;{item.name}&quot; as purchased
          </p>
          <div className="flex gap-2">
            <input
              type="number"
              placeholder="Price paid"
              value={purchasePrice}
              onChange={(e) => setPurchasePrice(e.target.value)}
              className={`flex-1 px-2 py-1.5 rounded text-sm ${isDarkMode ? 'bg-gray-600 text-white' : 'bg-gray-100 border'}`}
              autoFocus
            />
            <select
              value={purchaseCity}
              onChange={(e) => setPurchaseCity(e.target.value)}
              className={`flex-1 px-2 py-1.5 rounded text-sm ${isDarkMode ? 'bg-gray-600 text-white' : 'bg-gray-100 border'}`}
            >
              <option value="">📍 City</option>
              {cities.map(city => (
                <option key={city.id} value={city.id}>{city.name}</option>
              ))}
            </select>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => {
                onPurchase(item.id, parseFloat(purchasePrice) || 0, purchaseCity);
                setShowPurchaseForm(false);
              }}
              className="flex-1 py-1.5 bg-green-500 text-white rounded text-sm font-medium hover:bg-green-600"
            >
              Confirm Purchase
            </button>
            <button
              onClick={() => setShowPurchaseForm(false)}
              className={`px-3 py-1.5 rounded text-sm ${isDarkMode ? 'bg-gray-600 hover:bg-gray-500' : 'bg-gray-200 hover:bg-gray-300'}`}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default WishlistCard;
